import { playTone } from './audio';

// 5-note C-major arpeggio (C5→E5→G5→C6→E6) with a final harmonic layer
// (C6 at offset 480 ms) — a "tada!" landing. Triangle wave throughout for
// warmth.
//
// TODO: when the M3 theme registry lands, themes own their sounds (see
// plan/03 §Theme contract — `sounds?: { ding?: SoundSpec; fanfare?: SoundSpec }`).
// This synth becomes the default-theme implementation; other themes can
// override with their own waveform, MP3, or ramp.
export function playFanfare(): void {
  playTone(523.25, 280, 0, 0.2, 'triangle'); // C5
  playTone(659.25, 280, 130, 0.2, 'triangle'); // E5
  playTone(783.99, 280, 260, 0.2, 'triangle'); // G5
  playTone(1046.5, 340, 390, 0.22, 'triangle'); // C6
  playTone(1318.51, 400, 480, 0.22, 'triangle'); // E6
  playTone(1046.5, 400, 480, 0.12, 'triangle'); // C6 harmony layer
}
